export interface TipoPagamentoModel {
    name: string;
    descricao: string;
}

export const tiposPagamento: TipoPagamentoModel[] = [
    { name: 'VALOR_ADICIONAL_EXTRA', descricao: 'Valor adicional extra' },
    { name: 'VALOR_ADICIONAL', descricao: 'Valor adicional' },
    { name: 'SERVICO', descricao: 'Valor de serviço' },
];